import { render, staticRenderFns } from "./propertyCategoryListing.vue?vue&type=template&id=42b2a0d6&"
import script from "./propertyCategoryListing.vue?vue&type=script&lang=js&"
export * from "./propertyCategoryListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports